import {
  GET_LIST_INVOICE_TEMPLATE,
  GET_LIST_INVOICE_TEMPLATE_FAIL,
  GET_LIST_INVOICE_TEMPLATE_SUCCESS,
  GET_LIST_ROOT_INVOICE_TEMPLATE,
  GET_LIST_ROOT_INVOICE_TEMPLATE_FAIL,
  GET_LIST_ROOT_INVOICE_TEMPLATE_SUCCESS,
  GET_DETAIL_INVOICE_TEMPLATE,
  GET_DETAIL_INVOICE_TEMPLATE_FAIL,
  GET_DETAIL_INVOICE_TEMPLATE_SUCCESS,
  CREATE_INVOICE_TEMPLATE,
  CREATE_INVOICE_TEMPLATE_FAIL,
  CREATE_INVOICE_TEMPLATE_SUCCESS,
  RESET_CREATE_INVOICE_TEMPLATE_STATE,
  UPDATE_INVOICE_TEMPLATE,
  UPDATE_INVOICE_TEMPLATE_FAIL,
  UPDATE_INVOICE_TEMPLATE_SUCCESS,
  DELETE_INVOICE_TEMPLATE,
  DELETE_INVOICE_TEMPLATE_FAIL,
  DELETE_INVOICE_TEMPLATE_SUCCESS,
  GET_LIST_INVOICE_TYPE,
  GET_LIST_INVOICE_TYPE_SUCCESS,
  GET_LIST_INVOICE_TYPE_FAIL,
} from "./actionTypes";

const initialState = {
  // List Invoice Symbol
  list: {
    items: [],
    totalCount: 1,
    columnsVisible: null,
    params: {
      sizePerPage: 10,
      page: 1,
      sort: "",
      columnFilter: {}, // Column filter
      keywords: "", // Input search all
    },
  },
  loadingList: false,
  errorList: null,

  listRoot: {
    items: [],
    totalCount: 1,
    columnsVisible: null,
    params: {
      sizePerPage: 12,
      page: 1,
      sort: "",
      columnFilter: {}, // Column filter
      keywords: "", // Input search all
    },
  },
  loadingListRoot: false,
  errorListRoot: null,

  // Create Invoice Symbol
  create: null,
  loadingCreate: false,
  errorCreate: null,

  // Detail Invoice Symbol
  detail: null,
  loadingDetail: false,
  errorDetail: null,

  // Update Invoice Symbol
  update: null,
  loadingUpdate: false,
  errorUpdate: null,

  // Delete Invoice Symbol
  delete: null,
  loadingDelete: false,
  errorDelete: false,

  // Active Invoice Symbol
  active: null,
  loadingActive: false,
  errorActive: null,

  // List Invoice Type
  listInvoiceType: [],
  loadingListInvoiceType: false,
  errorListInvoiceType: null,
};

const invoiceTemplateReducer = (state = initialState, action) => {
  switch (action.type) {
    // List Invoice template
    case GET_LIST_INVOICE_TEMPLATE:
      return {
        ...state,
        loadingList: true,
        errorList: null,
      };
    case GET_LIST_INVOICE_TEMPLATE_SUCCESS:
      return {
        ...state,
        errorList: null,
        loadingList: false,
        list: {
          ...state.list,
          items: action.payload.items,
          totalCount: action.payload._meta
            ? action.payload._meta.totalCount
            : action.payload.items.length,
        },
      };
    case GET_LIST_INVOICE_TEMPLATE_FAIL:
      return {
        ...state,
        loadingList: false,
        errorList: action.payload,
      };

    // List Root Invoice template
    case GET_LIST_ROOT_INVOICE_TEMPLATE:
      return {
        ...state,
        listRoot: {
          ...state.listRoot,
          items: [],
        },
        loadingListRoot: true,
        errorListRoot: null,
      };
    case GET_LIST_ROOT_INVOICE_TEMPLATE_SUCCESS:
      return {
        ...state,
        errorListRoot: null,
        loadingListRoot: false,
        listRoot: {
          ...state.listRoot,
          items: action.payload.items,
          totalCount: action.payload._meta
            ? action.payload._meta.totalCount
            : action.payload.items.length,
        },
      };
    case GET_LIST_ROOT_INVOICE_TEMPLATE_FAIL:
      return {
        ...state,
        loadingListRoot: false,
        errorListRoot: action.payload,
      };

    // Detail Invoice template
    case GET_DETAIL_INVOICE_TEMPLATE:
      return {
        ...state,
        detail: null,
        loadingDetail: true,
        errorDetail: null,
      };
    case GET_DETAIL_INVOICE_TEMPLATE_SUCCESS:
      return {
        ...state,
        errorDetail: null,
        loadingDetail: false,
        detail: action.payload,
      };
    case GET_DETAIL_INVOICE_TEMPLATE_FAIL:
      return {
        ...state,
        loadingDetail: false,
        errorDetail: action.payload,
      };

    // Create Invoice template
    case CREATE_INVOICE_TEMPLATE:
      return {
        ...state,
        loadingCreate: true,
        errorCreate: null,
      };
    case CREATE_INVOICE_TEMPLATE_SUCCESS:
      return {
        ...state,
        errorCreate: null,
        loadingCreate: false,
        detail: action.payload,
        create: { data: action.payload, success: true },
      };
    case CREATE_INVOICE_TEMPLATE_FAIL:
      return {
        ...state,
        loadingCreate: false,
        errorCreate: action.payload,
      };
    case RESET_CREATE_INVOICE_TEMPLATE_STATE:
      return {
        ...state,
        loadingCreate: false,
        create: null,
        errorCreate: null,
      };

    // Update Invoice template
    case UPDATE_INVOICE_TEMPLATE:
      return {
        ...state,
        loadingUpdate: true,
        errorUpdate: null,
      };
    case UPDATE_INVOICE_TEMPLATE_SUCCESS:
      return {
        ...state,
        detail: action.payload,
        update: { data: action.payload, success: true },
        errorUpdate: null,
        loadingUpdate: false,
      };
    case UPDATE_INVOICE_TEMPLATE_FAIL:
      return {
        ...state,
        loadingUpdate: false,
        errorUpdate: action.payload,
      };

    // Delete Invoice template
    case DELETE_INVOICE_TEMPLATE:
      return {
        ...state,
        delete: null,
        errorDelete: null,
        loadingDelete: true,
      };
    case DELETE_INVOICE_TEMPLATE_SUCCESS:
      return {
        ...state,
        delete: { data: action.payload, success: true },
        errorDelete: null,
        loadingDelete: false,
      };
    case DELETE_INVOICE_TEMPLATE_FAIL:
      return {
        ...state,
        delete: null,
        loadingDelete: false,
        errorDelete: action.payload,
      };

    // Loading list invoice type
    case GET_LIST_INVOICE_TYPE:
      return {
        ...state,
        loadingListInvoiceType: true,
        errorListInvoiceType: null,
      };
    case GET_LIST_INVOICE_TYPE_SUCCESS:
      return {
        ...state,
        listInvoiceType: action.payload,
        loadingListInvoiceType: false,
        errorListInvoiceType: null,
      };
    case GET_LIST_INVOICE_TYPE_FAIL:
      return {
        ...state,
        loadingListInvoiceType: false,
        errorListInvoiceType: null,
      };

    default:
      return state;
  }
};

export default invoiceTemplateReducer;
